import classNames from "classnames";
import React from "react";
import { Clickable } from "../../button/Clickable";
import { Icon } from "../../graphic/Icon";
import styles from "./SiteLinkCard.scss";

/**
 * Card-shaped link with an icon, title, description and an arrow. Turns blue on hover.
 * @param icon – name from the icon list
 */
export const SiteLinkCard = ({ icon, title, description, link, className }) => {
    return (
        <Clickable link={link} className={classNames(styles.base, className)}>
            <span className={styles.icon}>
                <Icon name={icon} />
            </span>
            <span className={styles.title}>{title}</span>
            {description ? <span className={styles.description}>{description}</span> : null}
            <span className={styles.arrow}>
                <Icon name="arrow-right" />
            </span>
        </Clickable>
    );
};
